<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.submittedList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">

                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>{{$t('form.book.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.firstName')}}</label>
                                    <input type="text" v-model="search.firstName" @keyup="searchStudents"
                                        class="form-control">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.lastName')}}</label>
                                    <input type="text" v-model="search.lastName" @keyup="searchStudents"
                                        class="form-control">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.studentNumber')}}</label>
                                    <input type="text" class="form-control" @keyup="searchStudents"
                                        v-model="search.number">
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.birthDate')}}</label>
                                    <input type="date" v-model="search.birthDate" @change="searchStudents"
                                        class="form-control">
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="detailedSearch">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.book.birthPlace')}}</label>
                                    <input type="text" v-model="search.birthPlace" @keyup="searchStudents"
                                        class="form-control">
                                </div>
                            </div>

                            <div class="col-12">
                                <hr>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('form.book.presetName')">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.submittedList')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                            <thead>
                                <tr class="header">
                                    <th>{{$t('form.book.studentName')}}</th>
                                    <th class="text-right fix-action pr-5">{{$t('form.book.action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(student, index) in studentList" v-bind:key="index">
                                <tr @dblclick="goToEdit(student.ID)">
                                    <td>{{student.StudentNumber}} - {{student.FirstName}} {{student.LastName}}</td>
                                   
                                    <td class="text-right">
                                         <button class="btn btn-info btn-sm" @click="goToShow(student.ID)">
                                            <i class="fas fa-list"></i></button>

                                        <button class="btn btn-info btn-sm" @click="goToEdit(student.ID)">
                                            <span class="fa fa-edit"></span></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: ['permissions'],
        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                presetSelected: false,
                detailedSearch: false,

                pagination: {
                    current_page: 1
                },

                search: {},
                preset: {
                    name: '',
                    entity: 'ViewEditSubmissions',
                    value: {}
                },

                studentList: [],
                presetList: []
            }
        },

        mounted() {
            this.isLoading = true;
            if (!this.permissions.viewBooksSubmissions) {
                this.$router.push('/');
                return;
            }

            if (localStorage.getItem('filter-received')) {
                this.search = JSON.parse(localStorage.getItem('filter-received'));
            }

            this.getStudents();
            this.getPresets();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-received', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {
            goToShow(id) {
                this.$router.push({
                    name: "BookSubmittedShow",

                    params: {
                        id: id
                    }
                });
            },
            getStudents() {
                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                this.isLoading = true;
                axios
                    .get("/api/students?page=" + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.isLoading = false;

                        this.studentList = response.data.data.data;
                        this.pagination = response.data.pagination;
                    })

                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getStudents();
            },

            clearSearch() {
                this.search = {};
                this.searchStudents();
            },

            searchStudents() {
                this.pagination.current_page = 1;
                this.getStudents();
            },

            goToEdit(id) {
                if (!this.permissions.editBooksSubmissions) return;

                this.$router.push({
                    name: "BookSubmissionEdit",

                    params: {
                        id: id
                    }
                });
            },

            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);
                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.search = {};
                    this.preset = {
                        entity: 'ViewEditSubmissions'
                    };
                    this.alert = false;
                    this.presetSelected = false;
                    this.searchStudents();
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchStudents();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));
                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.search = {};
                                this.searchStudents();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>

<style scoped></style>
